module.exports = __webpack_public_path__ + "img/dentist_thumbnail.da1f7364.jpg";